module.exports = __webpack_public_path__ + "static/img/logodi2.cf4b8c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logodi2.png
// module id = Aj07
// module chunks = 21